<template>
  <div class="404 text-center">
    <h1>Sorry...</h1>
    <p>该语言的文档尚未更新，可以暂时查看其他语言版本。</p>
  </div>
</template>